// Language metadata for all 82 languages
const languageMetadata = {
    // EU Languages (23)
    ar: { name: 'العربية', flag: '🇸🇦', dir: 'rtl' },
    bg: { name: 'Български', flag: '🇧🇬', dir: 'ltr' },
    cs: { name: 'Čeština', flag: '🇨🇿', dir: 'ltr' },
    da: { name: 'Dansk', flag: '🇩🇰', dir: 'ltr' },
    de: { name: 'Deutsch', flag: '🇩🇪', dir: 'ltr' },
    el: { name: 'Ελληνικά', flag: '🇬🇷', dir: 'ltr' },
    en: { name: 'English', flag: '🇬🇧', dir: 'ltr' },
    es: { name: 'Español', flag: '🇪🇸', dir: 'ltr' },
    fi: { name: 'Suomi', flag: '🇫🇮', dir: 'ltr' },
    fr: { name: 'Français', flag: '🇫🇷', dir: 'ltr' },
    hr: { name: 'Hrvatski', flag: '🇭🇷', dir: 'ltr' },
    hu: { name: 'Magyar', flag: '🇭🇺', dir: 'ltr' },
    it: { name: 'Italiano', flag: '🇮🇹', dir: 'ltr' },
    nl: { name: 'Nederlands', flag: '🇳🇱', dir: 'ltr' },
    no: { name: 'Norsk', flag: '🇳🇴', dir: 'ltr' },
    pl: { name: 'Polski', flag: '🇵🇱', dir: 'ltr' },
    pt: { name: 'Português', flag: '🇵🇹', dir: 'ltr' },
    ro: { name: 'Română', flag: '🇷🇴', dir: 'ltr' },
    ru: { name: 'Русский', flag: '🇷🇺', dir: 'ltr' },
    sk: { name: 'Slovenčina', flag: '🇸🇰', dir: 'ltr' },
    sv: { name: 'Svenska', flag: '🇸🇪', dir: 'ltr' },
    tr: { name: 'Türkçe', flag: '🇹🇷', dir: 'ltr' },
    uk: { name: 'Українська', flag: '🇺🇦', dir: 'ltr' },

    // African Languages (18)
    af: { name: 'Afrikaans', flag: '🇿🇦', dir: 'ltr' },
    am: { name: 'አማርኛ', flag: '🇪🇹', dir: 'ltr' },
    ff: { name: 'Fulfulde', flag: '🇲🇱', dir: 'ltr' },
    ha: { name: 'Hausa', flag: '🇳🇬', dir: 'ltr' },
    ig: { name: 'Igbo', flag: '🇳🇬', dir: 'ltr' },
    mg: { name: 'Malagasy', flag: '🇲🇬', dir: 'ltr' },
    rw: { name: 'Kinyarwanda', flag: '🇷🇼', dir: 'ltr' },
    so: { name: 'Soomaali', flag: '🇸🇴', dir: 'ltr' },
    sw: { name: 'Kiswahili', flag: '🇰🇪', dir: 'ltr' },
    ti: { name: 'ትግርኛ', flag: '🇪🇷', dir: 'ltr' },
    wo: { name: 'Wolof', flag: '🇸🇳', dir: 'ltr' },
    xh: { name: 'isiXhosa', flag: '🇿🇦', dir: 'ltr' },
    yo: { name: 'Yorùbá', flag: '🇳🇬', dir: 'ltr' },
    zu: { name: 'isiZulu', flag: '🇿🇦', dir: 'ltr' },

    // Asian Languages (19)
    fa: { name: 'فارسی', flag: '🇮🇷', dir: 'rtl' },
    fil: { name: 'Filipino', flag: '🇵🇭', dir: 'ltr' },
    he: { name: 'עברית', flag: '🇮🇱', dir: 'rtl' },
    id: { name: 'Bahasa Indonesia', flag: '🇮🇩', dir: 'ltr' },
    ja: { name: '日本語', flag: '🇯🇵', dir: 'ltr' },
    ka: { name: 'ქართული', flag: '🇬🇪', dir: 'ltr' },
    kk: { name: 'Қазақ', flag: '🇰🇿', dir: 'ltr' },
    km: { name: 'ខ្មែរ', flag: '🇰🇭', dir: 'ltr' },
    ko: { name: '한국어', flag: '🇰🇷', dir: 'ltr' },
    lo: { name: 'ລາວ', flag: '🇱🇦', dir: 'ltr' },
    mn: { name: 'Монгол', flag: '🇲🇳', dir: 'ltr' },
    ms: { name: 'Bahasa Melayu', flag: '🇲🇾', dir: 'ltr' },
    my: { name: 'မြန်မာ', flag: '🇲🇲', dir: 'ltr' },
    ps: { name: 'پشتو', flag: '🇦🇫', dir: 'rtl' },
    th: { name: 'ไทย', flag: '🇹🇭', dir: 'ltr' },
    uz: { name: 'Ўзбек', flag: '🇺🇿', dir: 'ltr' },
    vi: { name: 'Tiếng Việt', flag: '🇻🇳', dir: 'ltr' },
    zh: { name: '中文', flag: '🇨🇳', dir: 'ltr' },

    // Indian Languages (22)
    as: { name: 'অসমীয়া', flag: '🇮🇳', dir: 'ltr' },
    bn: { name: 'বাংলা', flag: '🇮🇳', dir: 'ltr' },
    brx: { name: 'बड़ो', flag: '🇮🇳', dir: 'ltr' },
    doi: { name: 'डोगरी', flag: '🇮🇳', dir: 'ltr' },
    gu: { name: 'ગુજરાતી', flag: '🇮🇳', dir: 'ltr' },
    hi: { name: 'हिन्दी', flag: '🇮🇳', dir: 'ltr' },
    kn: { name: 'ಕನ್ನಡ', flag: '🇮🇳', dir: 'ltr' },
    kok: { name: 'कोंकणी', flag: '🇮🇳', dir: 'ltr' },
    ks: { name: 'کٲشُر', flag: '🇮🇳', dir: 'rtl' },
    mai: { name: 'मैथिली', flag: '🇮🇳', dir: 'ltr' },
    ml: { name: 'മലയാളം', flag: '🇮🇳', dir: 'ltr' },
    mni: { name: 'ম্যানিপুরি', flag: '🇮🇳', dir: 'ltr' },
    mr: { name: 'मराठी', flag: '🇮🇳', dir: 'ltr' },
    ne: { name: 'नेपाली', flag: '🇳🇵', dir: 'ltr' },
    or: { name: 'ଓଡିଆ', flag: '🇮🇳', dir: 'ltr' },
    pa: { name: 'ਪੰਜਾਬੀ', flag: '🇮🇳', dir: 'ltr' },
    sa: { name: 'संस्कृत', flag: '🇮🇳', dir: 'ltr' },
    sd: { name: 'سنڌي', flag: '🇵🇰', dir: 'rtl' },
    ta: { name: 'தமிழ்', flag: '🇮🇳', dir: 'ltr' },
    te: { name: 'తెలుగు', flag: '🇮🇳', dir: 'ltr' },
    ur: { name: 'اردو', flag: '🇵🇰', dir: 'rtl' },

    // Latin American Languages (8)
    ay: { name: 'Aymara', flag: '🇧🇴', dir: 'ltr' },
    gn: { name: 'Guarani', flag: '🇵🇾', dir: 'ltr' },
    ht: { name: 'Kreyòl Ayisyen', flag: '🇭🇹', dir: 'ltr' },
    nah: { name: 'Nahuatl', flag: '🇲🇽', dir: 'ltr' },
    'pt-BR': { name: 'Português (Brasil)', flag: '🇧🇷', dir: 'ltr' },
    qu: { name: 'Quechua', flag: '🇵🇪', dir: 'ltr' }
};

export { languageMetadata };
